import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <div>법인명: 주식회사 달려라커피 │ 대표: 안준호</div>
      <div>주소: 경기 고양시 일산동구 호수로 446번길 66-11, 1층 │ 사업자등록번호: 870-81-03332</div>
      <div>이메일: dalryeoracoffee@naver.com</div>
    </div>
  )
}

export default Footer